import {
  Box,
  CardHeader,
  Card,
  List,
  ListItemAvatar,
  ListItem,
  ListItemText,
  Typography,
  Divider,
  useTheme
} from '@mui/material';
import { OrdersGrandSummary } from 'src/services/apiService/response-models/report';
import { useTranslation } from 'react-i18next';
import PaymentTwoToneIcon from '@mui/icons-material/PaymentTwoTone';
import Text from 'src/components/Text';

interface SalesByPaymentTypeProps {
  salesByPaymentType?: Record<string, OrdersGrandSummary>;
}

function SalesByPaymentType({ salesByPaymentType }: SalesByPaymentTypeProps) {
  const { t }: { t: any } = useTranslation();
  const theme = useTheme();

  return (
    <Card variant="outlined">
      <CardHeader
        sx={{ p: 3 }}
        disableTypography
        title={
          <Typography
            variant="h4"
            sx={{ fontSize: `${theme.typography.pxToRem(16)}` }}
          >
            {t('Sales By Payment Type')}
          </Typography>
        }
      />
      <Divider />
      <List sx={{ py: 0 }}>
        {salesByPaymentType && Object.entries(salesByPaymentType).length > 0 ? (
          Object.entries(salesByPaymentType).map(([type, summary]) => (
            <ListItem key={type} sx={{ alignItems: 'flex-start', p: 2 }}>
              <ListItemAvatar sx={{ mr: 2, display: 'flex', alignItems: 'center', minWidth: 0 }}>
                <PaymentTwoToneIcon
                  sx={{ fontSize: `${theme.typography.pxToRem(23)}`, color: `${theme.colors.info.main}` }}
                />
              </ListItemAvatar>
              <ListItemText
                primary={<Typography variant="h4">{t(type)}</Typography>}
                secondary={
                  <Typography noWrap variant="subtitle2">
                    {t('Orders')}: {summary.ordersCount} | {t('Total')}: ${summary.orderTotal?.toLocaleString()}
                  </Typography>
                }
              />
              <Box alignSelf="center">
                <Typography variant="h4">
                  <Text color="primary">${summary.orderTotal?.toLocaleString()}</Text>
                </Typography>
              </Box>
            </ListItem>
          ))
        ) : (
          <ListItem>
            <ListItemText primary={t('No data available')} />
          </ListItem>
        )}
      </List>
    </Card>
  );
}

export default SalesByPaymentType;
